module.exports = __webpack_public_path__ + "static/hero-video-with-overlay-4f0c110f74d21499caf6a38572ea76f3.jpg";